'use strict';
var $ = require('jquery');

var $modalContainer = $('.modal-container');
var $modalContent = $modalContainer.find('.modal-content-container-inner');
var $closeModalButton = $modalContainer.find('.modal-close');

var $modalSectionBody = $modalContainer.find('.modal-section-body');

$closeModalButton.on('click', function() {
    hide();
});


$modalContainer.on('click', function () {
    hide();
});
$modalContent.on('click', function (e) {
    e.stopPropagation();
});
///////// START CODE GROUP ---> ///////
//The following chunk of code is an elaborate way to prevent the body from scrolling
//in the background while on Safari iOS, which ignore the overflow: hidden CSS
//that prevents the same thing on desktop. We basically have to start and stop
//touch event propagation based on the scrolling and visibility status of of the modal. 

$(document).bind('touchmove', function(e){
  e.preventDefault();           
});

$('body').bind('touchmove', function(e){
    var canscroll = !$('body').hasClass('no-scroll');
    if (canscroll) {
        e.stopPropagation();
    } else {
        e.preventDefault();
    }
});

var ts;
$modalContainer.bind('touchstart', function(e) {
    ts = e.originalEvent.touches[0].clientY;
});

$modalContainer.bind('touchmove', function(e){
    var te = e.originalEvent.changedTouches[0].clientY;
    var scrollTop = $modalContainer.scrollTop();

    if (ts > te) {

        var maxScroll = $modalContent.height() - $modalContainer.height() + 40;
        var distanceFromMaxTop = scrollTop - maxScroll;

        if (distanceFromMaxTop < 0) {
            //permit scrolling
            e.stopPropagation();
        }
    } else {
        if (scrollTop > 0) {
            e.stopPropagation();
        }
    }
    
});
////////// <---  END //////////////////

function makeSubject(subject) {

    var html = '';
    html += '<div class="modal-subject">';
    if (subject.subtitle) {
        html += '   <h4>' + subject.subtitle + '</h4>';
    }
    html += '   <p class="modal-subject-body">' + subject.body + '</p>';
    html += '</div>';

    //double it!
    // html += html;

    return html;
}

function setupPositions() {

}

function hide() {
    $modalContainer.hide();
    $('body').removeClass('no-scroll');
}

function show(options) {    
    $modalContainer.find('.modal-header').html(options.title);
    var $modalAttributeContent = $modalContainer.find('.modal-attr-content');

    var contentHTML = '';
    if (options.body) {
        $modalSectionBody.show();
        $modalSectionBody.html(options.body);
    } else {
        $modalSectionBody.hide();
        $modalSectionBody.html('');
    }
    
    if (options.subjects) {
        $modalAttributeContent.show();
        options.subjects.forEach(function(subject) {
            contentHTML += makeSubject(subject);
        });

        if (options.subjects.length > 1) {
            $modalAttributeContent.addClass('multi-column');
        } else {
            $modalAttributeContent.removeClass('multi-column');
        }
    } else {
        $modalAttributeContent.hide();
    }

    $modalAttributeContent.html(contentHTML);

    setupPositions();

    // setTimeout(function () {
    $('body').addClass('no-scroll');
    $modalContainer.fadeIn('fast');
    // }, 100);

    

}

// show();

module.exports = {
    show: function(options) {
        show(options);
    },
    hide: function (){
        hide();
    }
};